import colorTokens from '../../../constants/design_system/colors';
import { useState } from 'react';
import CustomTooltip from '../Tooltip/CustomTooltip';

export type BaseButtonProps = {
  children: React.ReactNode;
  type: 'primary' | 'accent' | 'secondary' | 'link' | 'text' | 'orange';
  size: 'small' | 'medium' | 'large';
  active?: boolean;
  danger?: boolean;
  disabled?: boolean;
  onClick?: (event: any) => void;
  disabledTooltip?: string;
  className?: string;
};

export const BaseButton = (props: BaseButtonProps) => {
  const { children, type, size, active, danger, disabled, onClick, disabledTooltip, className } = props;
  const [isHovered, setIsHovered] = useState(false);

  let bgColor = colorTokens.brand['taskonio-green'];
  let textColor = colorTokens.brand.white;
  let borderColor = colorTokens.brand['taskonio-green'];
  let activeBorderColor = colorTokens.taskonioGreen[300];

  const disabledBgColor = colorTokens.neutral[300];
  const disabledTextColor = colorTokens.neutral[700];
  const disabledBorderColor = colorTokens.neutral[500];
  const disabledActiveBorderColor = colorTokens.brand.white;

  switch (type) {
    case 'primary':
      bgColor = danger ? colorTokens.red[isHovered ? 500 : 600] : colorTokens.taskonioGreen[isHovered ? 500 : 600];
      textColor = colorTokens.brand.white;
      borderColor = danger ? colorTokens.red[isHovered ? 500 : 600] : colorTokens.taskonioGreen[isHovered ? 500 : 600];
      activeBorderColor = danger ? colorTokens.red[300] : colorTokens.taskonioGreen[300];
      break;
    case 'accent':
      bgColor = colorTokens.blue[isHovered ? 500 : 600];
      textColor = colorTokens.brand.white;
      borderColor = colorTokens.blue[isHovered ? 500 : 600];
      activeBorderColor = colorTokens.blue[300];
      break;
    case 'secondary':
      bgColor = colorTokens.brand.white;
      textColor = danger
        ? colorTokens.red[isHovered ? 500 : 600]
        : isHovered
          ? colorTokens.taskonioGreen[600]
          : colorTokens.neutral[900];
      borderColor = danger
        ? colorTokens.red[isHovered ? 500 : 600]
        : isHovered
          ? colorTokens.taskonioGreen[600]
          : colorTokens.neutral[300];
      activeBorderColor = danger ? colorTokens.red[300] : colorTokens.taskonioGreen[300];
      break;
    case 'link':
      bgColor = colorTokens.brand.white;
      textColor = danger ? colorTokens.red[isHovered ? 500 : 600] : colorTokens.blue[isHovered ? 500 : 600];
      borderColor = colorTokens.brand.white;
      activeBorderColor = danger ? colorTokens.red[300] : colorTokens.blue[300];
      break;
    case 'text':
      bgColor = danger
        ? isHovered
          ? colorTokens.red[300]
          : colorTokens.brand.white
        : isHovered
          ? colorTokens.neutral[300]
          : colorTokens.brand.white;
      textColor = danger ? colorTokens.red[600] : colorTokens.neutral[900];
      borderColor = colorTokens.brand.white;
      activeBorderColor = danger ? colorTokens.red[300] : colorTokens.taskonioGreen[300];
      break;
    case 'orange':
      bgColor = colorTokens.brand.white;
      textColor = colorTokens.orange[isHovered ? 500 : 600];
      borderColor = colorTokens.orange[300];
      activeBorderColor = colorTokens.orange[300];
      break;
  }

  const heightStr = size === 'small' ? 'h-6' : size === 'medium' ? 'h-8' : 'h-10';

  const baseButton = (
    <div
      className={`flex items-center justify-center gap-1 px-3 rounded text-sm font-medium border border-solid ${heightStr}  ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      style={{
        backgroundColor: disabled ? disabledBgColor : bgColor,
        color: disabled ? disabledTextColor : textColor,
        borderColor: disabled ? disabledBorderColor : borderColor,
        outline: active ? '4px solid ' + activeBorderColor : 'none',
      }}
      onClick={(event) => {
        if (disabled) {
          return;
        }
        onClick?.(event);
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </div>
  );

  return disabled && disabledTooltip ? (
    <CustomTooltip title={disabledTooltip} overlayStyle={{ pointerEvents: 'auto' }}>
      <div className="pointer-events-auto">{baseButton}</div>
    </CustomTooltip>
  ) : (
    baseButton
  );
};
